export enum SubscriptionType {
  FREE = "FREE",
  ESSENTIAL = "ESSENTIAL",
  ADVANCED = "ADVANCED",
  PROFESSIONAL = "PROFESSIONAL",
  FREE_YEAR = "FREE_YEAR",
  ESSENTIAL_YEAR = "ESSENTIAL_YEAR",
  ADVANCED_YEAR = "ADVANCED_YEAR",
  PROFESSIONAL_YEAR = "PROFESSIONAL_YEAR",
  EVENT_FREE = "EVENT_FREE",
  EVENT_ESSENTIAL = "EVENT_ESSENTIAL",
  EVENT_ADVANCED = "EVENT_ADVANCED",
  EVENT_PROFESSIONAL = "EVENT_PROFESSIONAL",
  ADDITIONAL_COLLABORATOR_COMPANY = "ADDITIONAL_COLLABORATOR_COMPANY",
}
